import { render } from "./SettingsTabMedicines.vue?vue&type=template&id=3df8e2c2"
import script from "./SettingsTabMedicines.vue?vue&type=script&lang=js"
export * from "./SettingsTabMedicines.vue?vue&type=script&lang=js"

import "./SettingsTabMedicines.vue?vue&type=style&index=0&id=3df8e2c2&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__